import { Breakpoint, useIsBreakpoint } from '@/hooks/useIsBreakpoint';
import { Carousel } from '../Carousel/Carousel';
import { IconCard } from '../IconCard/IconCard';
import { LinkButton } from '../LinkButton/LinkButton';

interface ProductInput {
  title: string;
  body: string;
  icon: string;
  buttonText: string;
  buttonLink: string;
}

export const ProductCards = ({ title, products }: { title: string; products: ProductInput[] }) => {
  const isMobile = useIsBreakpoint(Breakpoint.LG);
  const gridClass = products.length >= 3 ? 'grid-cols-3' : 'grid-cols-2';

  return (
    <>
      <div className="py-5">
        <h2 className="mt-0 mb-6 md:max-w-2/3">{title}</h2>
        {isMobile ? (
          <Carousel>
            {products.map(({ title, icon, body, buttonLink, buttonText }: ProductInput, idx: number) => (
              <div key={title + idx} className="flex-[1_1_0px]">
                <IconCard icon={icon} title={title} twoColumns={false} contents={body}>
                  <LinkButton
                    variant="tertiary"
                    link={buttonLink}
                    label={buttonText}
                    className="mt-5"
                    size={'smallPadded'}
                  />
                </IconCard>
              </div>
            ))}
          </Carousel>
        ) : (
          <ul className={`grid list-none gap-4 p-0 sm:grid-cols-1 sm:gap-6 md:grid-cols-2 lg:${gridClass}`}>
            {products.map(({ title, icon, body, buttonLink, buttonText }: ProductInput, idx: number) => (
              <li key={title + idx} className="flex-[1_1_0px]">
                <IconCard icon={icon} title={title} twoColumns={false} contents={body}>
                  <LinkButton
                    variant="tertiary"
                    link={buttonLink}
                    label={buttonText}
                    className="mt-5"
                    size={'smallPadded'}
                    aria-description={title}
                  />
                </IconCard>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};
